/**
 * Componente EdicionDatos
 * Datos básicos de la compra extraídos del XML
 */

import React from 'react';
import { Box, Grid, TextField, Typography, Alert, Chip } from '@mui/material';

const EdicionDatos = ({ compraData, onActualizar }) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Paso 2: Datos de la Factura
      </Typography>

      <Alert severity="info" sx={{ mb: 3 }}>
        Los datos extraídos del XML no son modificables. Solo la fecha de ingreso al sistema y la nota son editables.
      </Alert>

      <Grid container spacing={2}>
        {/* Número de Factura - NO editable */}
        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            label="Número de Factura"
            value={compraData.numero_factura || ''}
            disabled
            helperText="Extraído del XML"
          />
        </Grid>

        {/* Fecha de Factura - NO editable */}
        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            label="Fecha de Factura"
            type="date"
            value={compraData.fecha_factura || ''}
            disabled
            InputLabelProps={{ shrink: true }}
            helperText="Extraído del XML"
          />
        </Grid>

        {/* Código de Autorización - NO editable */}
        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            label="Código de Autorización"
            value={compraData.codigo_autorizacion || ''}
            disabled
            helperText="Extraído del XML"
          />
        </Grid>

        {/* Fecha de Ingreso al Sistema - SÍ editable */}
        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            label="Fecha de Ingreso al Sistema"
            type="date"
            value={compraData.fecha_ingreso || ''}
            onChange={(e) => onActualizar('fecha_ingreso', e.target.value)}
            InputLabelProps={{ shrink: true }}
            helperText="Modificable"
          />
        </Grid>

        {/* Proveedor - Nombre */}
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Proveedor (Razón Social)"
            value={compraData.proveedor_nombre || ''}
            disabled
            helperText="Extraído del XML"
          />
        </Grid>

        {/* Proveedor - RUC/CI (es el ID) */}
        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            label="RUC / CI Proveedor"
            value={compraData.proveedor_ruc || ''}
            disabled
            helperText="Se usa como identificador"
          />
        </Grid>

        {/* Dirección */}
        <Grid item xs={12} md={5}>
          <TextField
            fullWidth
            label="Dirección"
            value={compraData.proveedor_direccion || ''}
            disabled
            helperText="Extraído del XML"
          />
        </Grid>

        {/* Estado del proveedor */}
        <Grid item xs={12}>
          {compraData.proveedor_ruc && (
            <Chip
              label={compraData.proveedor_existente
                ? `✅ Proveedor registrado: ${compraData.proveedor_nombre}`
                : `⚠️ Proveedor nuevo - se creará automáticamente al guardar`
              }
              color={compraData.proveedor_existente ? 'success' : 'warning'}
              variant="outlined"
            />
          )}
        </Grid>

        {/* Nota/Observación - SÍ editable */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Nota/Observación"
            multiline
            rows={3}
            value={compraData.nota || ''}
            onChange={(e) => onActualizar('nota', e.target.value)}
            placeholder="Escriba una nota o comentario sobre esta compra..."
            helperText={`${(compraData.nota || '').length}/500 caracteres`}
            inputProps={{ maxLength: 500 }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default EdicionDatos;
